export const addCss = (el, attr = {}) => {
    if (Object.keys(attr).length === 0) return false;

    Object.keys(attr).forEach(key => {
        el.style[key] = attr[key];
    });
};

export const scrollPos = (elem, posTop) => {
    const scrollTop = window.scrollY;
    const trigger = scrollTop > posTop;

    elem.forEach(el => {
        if (trigger) {
            addCss(el, {
                position: "fixed",
                top: `100px`
            });
        } else {
            addCss(el, {
                position: "absolute",
                top: `0`
            });
        }
    });
};

export const shareScroll = (top = 100) => {
    const socialMedia = document.querySelectorAll(".jsShare");

    if (socialMedia.length > 0) {
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        const posTopFixed = windowHeight / 2;
        const posTop = top;

        if (windowWidth < 1024 || (windowWidth === 768 && windowHeight < 1025)) return false;

        socialMedia.forEach(el => {
            addCss(el, {
                zIndex: 99
            });

            scrollPos(socialMedia, posTop, posTopFixed);
        });

        window.addEventListener("scroll", () => {
            scrollPos(socialMedia, posTop, posTopFixed);
        });
    }
};
